import * as React from 'react';
/**
 *
 * Original name: file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A531
 *
 */
export const FileSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M92.192 26.95 82.05 16.808A12.913 12.913 0 0 0 72.857 13H24v94h72V36.142a12.915 12.915 0 0 0-3.808-9.192ZM86.758 30H79v-7.758L86.758 30ZM90 101H30V19h42.857c.048 0 .095.006.143.007V36h16.993c0 .048.007.094.007.142V101Z", fill: "currentColor" })));
